/**
 * Normalize learning_outcomes from API/DB into string[].
 * Postgres TEXT / JSON columns often arrive as a JSON string, not an array.
 */
export function normalizeLearningOutcomes(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw
      .map((item) => (typeof item === 'string' ? item : item == null ? '' : String(item)))
      .filter((s) => s.trim().length > 0);
  }

  if (raw == null) return [];

  if (typeof raw === 'object') {
    const obj = raw as Record<string, unknown>;
    if (Array.isArray(obj.items)) return normalizeLearningOutcomes(obj.items);
    if (Array.isArray(obj.outcomes)) return normalizeLearningOutcomes(obj.outcomes);
    const vals = Object.values(obj).filter((v): v is string => typeof v === 'string' && v.trim().length > 0);
    return vals;
  }

  if (typeof raw === 'string') {
    const s = raw.trim();
    if (!s || s === '[object Object]') return [];
    try {
      return normalizeLearningOutcomes(JSON.parse(s));
    } catch {
      // Plain prose stored as a single outcome
      return [s];
    }
  }

  return [];
}
